module.exports = __webpack_public_path__ + "static/woocommerce_google-pay-e8ab4833f1b5e00eedf619e92a0b7173.svg";